
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'
import i18n from '@/plugins/i18n'

const PageConst= {
  ACTION: {
    doAdd: { api: 'M1020SubjectService.doAdd'},
    getEdit: { api: 'M1020SubjectService.getEdit'},
    doEdit: { api: 'M1020SubjectService.doEdit'},
    doRead: { api: 'M1020SubjectService.doRead'},
    doDelete: { api: 'M1020SubjectService.doDelete'},
    doBrowse: { api: 'M1020SubjectService.M20401_doBrowse_AtDataTable'},
    getSubjectsDropdown: { api: 'M1020SubjectService.getSubjectsDropdown'},
  },
}

const module = {
  state: {
    PageConst,
    inited: false,

    subjectsList: [],
    valueList: {},

    defaultDoBrowse: {
      searchInfo: {
        search: '',
        delete_flag: 0
      },
      orderBy: {},
      doBrowseStatus: 'init'
    },
  },

  getters: {
    getSubjectTypeList: (state) => {
      return  [
        { value: 1, label: window.vue.$i18n.t('M20401.M20401Store.uMDQy8NI5kP74Cw85IlYu') },
        { value: 2, label: window.vue.$i18n.t('M20401.M20401Store.1vzf5MunLsmpsJJ5i1sSn') },
      ]
    }
  },

  mutations: {},

  actions: {
    async init ({ state }) {
      const res = await $this.$api.postData({
        data: {
          valueList: { api: 'T2010TeacherBasicService.C10101_getDropdownData' },
        }
      })
      state.valueList = res.valueList.output
      state.inited = true
    },
    // @deprecated
    async getSubjectsDropdown ({ state }, { studentClassification }) {
      const res = await $this.$api.postData({
        data: [{
          ...PageConst.ACTION.getSubjectsDropdown,
          input: { student_classification:studentClassification }
        }]
      })
      state.subjectsList = res[0].output;
    },
    async M20401_exportCSV ({ state }) {
      const res = await $this.$api.postData({
        data: [{
          api: 'M1020SubjectService.M20401_exportCSV',
          input: { searchInfo: state.searchInfo, orderBy: state.orderBy }
        }]
      })
      return res[0].output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
